module.exports = __webpack_public_path__ + "Flag-231.8da2e5d6562488b3b19a30f0c14f42db.svg";